const SWYM_MODAL_LABELS = ['your consent matters', 'are you sure? keep only on this device'];

function normalizeText(value) {
  return value.replace(/\s+/g, ' ').trim().toLowerCase();
}

function replaceHeading(heading) {
  const label = normalizeText(heading.textContent || '').replace(/\{\{\s*itemcount\s*\}\}/g, '').trim();
  if (!SWYM_MODAL_LABELS.some((target) => label.includes(target))) return;

  const replacement = document.createElement('div');

  for (const attribute of heading.attributes) {
    replacement.setAttribute(attribute.name, attribute.value);
  }

  while (heading.firstChild) {
    replacement.appendChild(heading.firstChild);
  }

  heading.replaceWith(replacement);
}

function cleanSwymHeadings(root = document) {
  const headings = root.querySelectorAll('h1, h2, h3, h4, h5, h6');
  headings.forEach(replaceHeading);
}

cleanSwymHeadings();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('h1, h2, h3, h4, h5, h6')) {
        replaceHeading(node);
      }

      cleanSwymHeadings(node);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
